import React from "react";
import {RadioGroupEntryProps} from "./types";
import {useIntl} from "react-intl";

export const RadioGroupEntry = ({
  id,
  label,
  description,
  value,
  checked,
  onChange,
  message,
  onMessageChange,
}: RadioGroupEntryProps) => {

  // hooks
  const intl = useIntl();

  return (
    <div
      onClick={() => {onChange(value)}}
      key={value}
      className="flex flex-row gap-4"
    >
      <input
        type="radio"
        id={value}
        name={id}
        checked={checked}
        className={`focus:ring-am-500 h-4 w-4 text-black-500 border-gray-300 cursor-pointer`}
        readOnly
      />
      <div className="flex flex-col gap-3 flex-1">
        <label
          htmlFor={value}
          className="flex flex-col gap-1 -mt-1"
        >
          <p className="font-medium text-base cursor-pointer">
            {label}
          </p>
          {!!description && (
            <p className="text-sm font-light text-gray-800">
              {description}
            </p>
          )}
        </label>
        {checked && (
          <textarea
            className="text-sm"
            rows={4}
            value={message}
            onChange={(e) => onMessageChange(e.target.value)}
            placeholder={intl.formatMessage({
              id: "quotation_decline_text",
              defaultMessage: "Inserisci un messaggio per il mittente (facoltativo)"
            })}
          />
        )}
      </div>
    </div>
  )
}